export default "__VITE_ASSET__BJnOcFXU__"